import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { HIDE_LITERALS } from 'constants/Environment';
import { Core } from 'managers';

function mapStateToProps({ literal }, ownProps) {
    let result = ' ';
    let reportLiteral = false;
    if (ownProps.literal) {
        const hasOwnProps = Object.prototype.hasOwnProperty.call(
            literal.literals,
            ownProps.literal,
        );
        reportLiteral = literal.literals && !hasOwnProps;
        const myLiteral = literal.literals ? literal.literals[ownProps.literal] : ownProps.literal;
        result = myLiteral && HIDE_LITERALS === 'SHOW' ? myLiteral : ownProps.literal;
    }

    return {
        showLoading: literal.loading,
        showError: literal.error,
        data: result,
        reportLiteral,
    };
}

class Literal extends React.Component {
    replace = (result) => {
        const { replaces = [] } = this.props;
        let resultAux = result;
        if (replaces && replaces.length > 0 && result.includes('%@')) {
            const results = result.replace(/%([0-9]+)\$s/g, '%@').split('%@');
            resultAux = [];
            results.forEach((text, index) => {
                resultAux.push(text);
                if (replaces.length > index) {
                    resultAux.push(replaces[index]);
                }
            });
        }
        return <Fragment>{resultAux}</Fragment>;
    };

    render() {
        const { showLoading, showError, data = '', reportLiteral } = this.props;
        const result = showError || showLoading ? '' : data;

        if (reportLiteral && data && data !== '') {
            Core.literalsManager.reportLiteral(data);
        }

        return this.replace(result);
    }
}

Literal.propTypes = {
    data: PropTypes.string,
    replaces: PropTypes.arrayOf(PropTypes.string),
    reportLiteral: PropTypes.bool,
    showLoading: PropTypes.bool,
    showError: PropTypes.bool,
};

export default connect(mapStateToProps)(Literal);
